export const faConnectElements = {
  prefix: 'fpm',
  iconName: 'fa-connect-elements',
  icon: [
    20,
    20,
    [],
    'e002',
    'M0 2.502v2.501h5.003V3.008h5.004v15.01h5.478V19c0 .54.011.981.024.981.053-.001 2.989-2.477 2.964-2.499a203.517 203.517 0 0 0-2.942-2.429c-.04-.016-.046.116-.046.967v.985h-4.497V1.995H5.003V0H0v2.502m3.99.016v1.504H1.013V1.013H3.99v1.505',
  ],
};
